<template>
  <div class="nav-bar">
    <div class="left-item">
      <div v-if="hasBack"
        @click="back"
        class="back">
        <font-awesome-icon icon="arrow-left" size="lg"/>
      </div>
    </div>
    <div class="title">
      {{ $l[$route.meta.name] }}
    </div>
    <div class="right-item">
    </div>
  </div>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'

export default {
  mixins: [ MixinLocale ],
  computed: {
    hasBack: function () {
      const nav = this.$route.meta.nav
      if (nav) {
        return nav.back
      }
      return false
    }
  },
  methods: {
    back: function () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgba(52, 152, 219, 1.0);
  color: white;
}

.title {
  font-size: 1.1em;
  font-weight: bold;
}

.back {
  padding-left: 15px;
}
</style>
